<template>
	<div
		class="c-contact-support-info"
		:class="{ '--is-vertical': isVertical }"
	>
		<div class="c-contact-support-info__container">
			<div class="c-contact-support-info__wrapper">
				<c-icon
					class="c-contact-support-info__icon"
					src="@icons/phone2"
					size="l"
				/>
				<p class="c-contact-support-info__title text-m-semibold">
					{{ $t('CONTACT_SUPPORT.TEL_BANK') }}
				</p>

				<div class="c-contact-support-info__telephone-numbers text-m-semibold">
					<c-telephone
						:number="telephones.number1"
						:textSizeClass="'text-m-semibold'"
					/>

					<span
						v-if="telephones.number2"
						class="c-contact-support-info__slash text-m-semibold"
					>
						{{ String('/') }}
					</span>

					<c-telephone
						v-if="telephones.number2"
						:number="telephones.number2"
						:textSizeClass="'text-m-semibold'"
					/>
				</div>

				<c-icon
					class="c-contact-support-info__icon"
					src="@icons/whatsapp"
					size="l"
				/>

				<p class="c-contact-support-info__title text-m-semibold">
					{{ $t('WHATSAPP') }}
				</p>

				<c-telephone
					:number="whatsapp"
					type="whatsapp"
					:textSizeClass="'text-m-semibold'"
				/>
			</div>
		</div>

		<div class="c-contact-support-info__container">
			<div class="c-contact-support-info__wrapper">
				<p class="c-contact-support-info__desc_phone text-m-medium">
					{{ $t('CONTACT_SUPPORT.TELEPHONE_TIME.WEEK') }}
				</p>
				<p class="c-contact-support-info__desc_phone text-m-medium">
					{{ $t('CONTACT_SUPPORT.TELEPHONE_TIME.WEEKEND') }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'pinia';
import { useAppStore } from '@local-modules/app/m-app';
import CIcon from '@components/c-icon.vue';
import CTelephone from '@components/c-telephone.vue';

export default {
	name: 'c-contact-support-info',

	components: {
		CIcon,
		CTelephone,
	},

	props: {
		isVertical: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		...mapState(useAppStore, ['whatsapp', 'telephone']),

		telephones({ telephone }) {
			const [number1, number2] = telephone.replace(/\s+/g, '').concat('/').split('/');

			return {
				number1,
				number2,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.c-contact-support-info {
	display: flex;
	position: relative;
	width: 100%;
	border: 1px solid RGB(var(--color-surface-dark));
	border-radius: var(--border-radius-m);
	padding: var(--spacing-l);
	gap: var(--spacing-m);
}

.c-contact-support-info.--is-vertical {
	flex-direction: column;
}

.c-contact-support-info.--is-vertical .c-contact-support-info__container {
	width: 100%;
}

.c-contact-support-info__container {
	display: flex;
	position: relative;
	width: 50%;
	justify-content: center;
	padding: var(--spacing-s);
}

.c-contact-support-info__wrapper {
	display: flex;
	position: relative;
	flex-direction: column;
	align-items: center;
	text-align: center;
	gap: var(--spacing-s);
	justify-content: center;
}

.c-contact-support-info__telephone-numbers {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
}

.c-contact-support-info__slash {
	padding: var(--spacing-none) var(--spacing-s);
}

.c-contact-support-info__desc_phone {
	white-space: pre-line;
}

.c-contact-support-info__desc {
	white-space: pre-wrap;
}

.c-contact-support-info__icon,
.c-contact-support-info__desc_phone,
.c-contact-support-info__desc {
	color: RGB(var(--cbnk-color-text-label));
}
</style>
